import { render } from "./hotspot-video.vue?vue&type=template&id=2704cb70"
import script from "./hotspot-video.vue?vue&type=script&lang=js"
export * from "./hotspot-video.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__